var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5V11C3 11.5523 3.44772 12 4 12H12C12.5523 12 13 11.5523 13 11V4.5C13 4.22386 12.7761 4 12.5 4H3.5C3.22386 4 3 4.22386 3 4.5Z",
    stroke: "#002A69",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L3.37404 4.91603C2.96242 4.64161 3.15668 4 3.65139 4H12.3486C12.8433 4 13.0376 4.64161 12.626 4.91602L8 8Z",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLine);
export default __webpack_public_path__ + "static/media/Mail_line.6416927af76af57767e7faba8ed18f23.svg";
export { ForwardRef as ReactComponent };